import { get, post, put } from './apiService';

const achievementService = {
  getAchievements: async () => {
    try {
      return await get('admin/getAchievements', { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'خطا در دریافت دستاوردها');
    }
  },
  updateAchievement: async (id, data) => {
    try {
      return await put('admin/updateAchievement', { id, ...data }, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'خطا در ویرایش دستاورد');
    }
  },
  createAchievement: async (data) => {
    try {
      return await post('admin/createAchievement', data, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'خطا در ایجاد دستاورد');
    }
  },
  refreshAchievements: async (data) => {
    try {
      return await post('admin/refreshAchievements', data, { withCredentials: false});
    } catch (err) {
      throw new Error(err.message || 'خطا در رفرش دستاوردها');
    }
  },
};

export default achievementService;
